







import Vue from 'vue'
import StaffList from '@/components/owner/OwnerStaffList.vue'
import OwnerNewStaff from '@/components/owner/OwnerNewStaff.vue'

export default Vue.extend({
  name: 'OwnerStaff',
  components: { StaffList, OwnerNewStaff },

  data() {
    return {}
  },
})
